import { FaFileContract } from "@onemind-services-llc/react-icons-ng/fa";
import { Fa6SquareArrowUpRight } from "@onemind-services-llc/react-icons-ng/fa6";
import { LuSlack, LuFolderLock } from "@onemind-services-llc/react-icons-ng/lu";
import { AiOutlineInteraction } from "@onemind-services-llc/react-icons-ng/ai";
import { RiSecurePaymentLine } from "@onemind-services-llc/react-icons-ng/ri";
import { IoReceiptOutline } from "@onemind-services-llc/react-icons-ng/io5";
import { MdOutlinePersonAddAlt } from "@onemind-services-llc/react-icons-ng/md";

export const SEC_ASSESSMENT_FEATURES = {
  title: "Why Choose Onemind for Security Assessments?",
  list: [
    {
      icon: MdOutlinePersonAddAlt,
      title: "Expert-Led Evaluations",
      content:
        "Get assessments conducted by certified cybersecurity professionals (CISSP, OSCP) with deep expertise in real-world threat landscapes.",
    },
    {
      icon: AiOutlineInteraction,
      title: "Actionable Remediation Plans",
      content:
        "Every assessment includes a prioritized remediation roadmap—backed by technical recommendations you can immediately act on.",
    },
    {
      icon: Fa6SquareArrowUpRight,
      title: "Continuous Improvement with Retesting",
      content:
        "We don’t stop at reporting. Optional retesting ensures your improvements are validated and risks truly mitigated.",
    },
    {
      icon: LuFolderLock,
      title: "Executive-Ready Reports",
      content:
        "Receive concise, impactful reporting designed for both technical teams and non-technical leadership to support decision-making.",
    },
    {
      icon: FaFileContract,
      title: "Framework-Aligned",
      content:
        "Our assessments align with top compliance standards like ISO 27001, NIST CSF, SOC 2, and PCI-DSS—keeping you audit-ready.",
    },
    {
      icon: IoReceiptOutline,
      title: "Threat-Informed Methodology",
      content:
        "We combine automated tools with manual testing approaches modeled on real attacker behavior, ensuring coverage beyond the basics.",
    },
    {
      icon: LuSlack,
      title: "SIEM-Ready Integrations",
      content:
        "Seamlessly integrate logs and threat insights with your existing SIEM tools for continuous visibility and faster response.",
    },
    {
      icon: RiSecurePaymentLine,
      title: "Secure Across All Layers",
      content:
        "From endpoint to cloud, wireless to physical, our assessments cover your full security stack—leaving no weak spots unchecked.",
    },
  ],
};
